import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const HeroSection = () => {
    return (
        <Container className="hero-section-container">
            <Row className="h-100">
                <Col xs md="8" className="d-flex flex-column justify-content-center text-start px-4"></Col>
                    <div className="mx-4">
                        <img src="/images/Paasimaa-RGB.png" height="100%"></img>
                    </div>
                <Col xs md="4">
                    <div className="img-wrapper"> </div>
                </Col>
            </Row>

        </Container>
        
    )


}

export default HeroSection